var _Drip$constant, _Drip$constant2;
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
// 处理猫眼微信站适配
import Drip from 'drip';
// ci json 文件
import f2eJson from '../../f2eci.json';
import cookie from '@/drip/utils/cookie';
// 处理新mweb服务的接口url
import { formatNewMwebUrl, getNewWebUrlByAjaxUrl, formatMarketingMwebUrl } from '@/utils';

// 生产环境
export var isProd = process.env.DEPLOY_ENV === 'production' || /product|ppe/.test(f2eJson.env);
// eslint-disable-next-line
export var isDev = process.env.DEPLOY_ENV === 'local' || f2eJson.env === 'test';

// 不同环境下的域名配置
export var wxMyDomainUrl = isProd ? 'm.maoyan.com/myshow/fe' : 'myshow.test.maoyan.com/fe';
// 电影北京域名
export var wxMyBjDomainUrl = isProd ? 'm.maoyan.com/dianpingmmweb' : 'canary5.fe.st.maoyan.com/dianpingmmweb';
// wxApi
export var wxApiUrl = "//s0.meituan.net/bs/delivr/0315c86:jsm/lib/weixin/jweixin-1.1.0.js";
// 猫眼微信环境标识
export var myOriginAndWx = /maoyan.com/.test(location.host) && window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) === 'micromessenger';
// 电影相关请求链接
export var wxConfigUrl = 'https://m.maoyan.com/wechat?channelId=70001';
// 站点协议
export var protocol = /^file/.test(location.protocol) ? "http://" : "//";
// 域名
export var domain = isProd ? "h5.dianping.com" : "h5.51ping.com";
// 页面访问路径前缀
export var preUrl = "".concat(protocol).concat(domain);
// 应用名
export var webName = "maoyan-show-h5";
// 日期格式
export var dateFmtStr = 'yyyy-MM-dd';
// ajax请求前缀
var _ajaxPreUrl = isProd ? Drip.constant.ajaxUrl : Drip.constant.ajaxBetaUrl;
export var ajaxPreUrl = cookie.get('mock') ? "".concat(_ajaxPreUrl, "/mock") : _ajaxPreUrl;

/*
 my/ianvs mysh/ianvs 这两个前缀都可以 
 新服务接口前缀 myshow/ajax 替换为 my/ianvs
*/
export var ianvsPreUrl = getNewWebUrlByAjaxUrl('my/ianvs', ajaxPreUrl);
export var dealAjaxPreUrl = "".concat(_ajaxPreUrl, "/tx");

// fans请求前缀
export var fansAjaxPreUrl = isProd ? 'https://fans.maoyan.com/myshow/ajax' : '//fans.test.maoyan.com/myshow/ajax';

// live请求前缀
var _livePreUrl = isProd ? 'https://yanchu.maoyan.com/api/mobile' : '//show.test.maoyan.com/api/mobile';
export var livePreUrl = cookie.get('mock') ? "".concat(_livePreUrl, "/mock") : _livePreUrl;

// 周边商品的url
export var mallUrl = isProd ? 'https://store.maoyan.com' : 'http://canary.movie.test.maoyan.com';

// 工具项目的url
export var toolUrl = isProd ? 'https://show.maoyan.com/app/myshow-alien/' : 'https://show.test.maoyan.com/app/myshow-alien/';

// 会员中心url
export var vipCenterUrl = isProd ? 'https://m.maoyan.com/apollo/vip' : 'https://i.test.maoyan.com/apollo/vip';
export var apiMobileUrl = '';

// 新mweb服务 ajax请求前缀
var _ajaxNewMwebPreUrl = isProd ? formatNewMwebUrl(Drip.constant.ajaxUrl) : formatNewMwebUrl(Drip.constant.ajaxBetaUrl);
export var ajaxNewMwebPreUrl = cookie.get('mock') ? "".concat(_ajaxNewMwebPreUrl, "/mock") : _ajaxNewMwebPreUrl;
export var ajaxMwebMarketingPreUrl = isProd ? formatMarketingMwebUrl((_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : _Drip$constant.ajaxUrl) : formatMarketingMwebUrl((_Drip$constant2 = Drip.constant) === null || _Drip$constant2 === void 0 ? void 0 : _Drip$constant2.ajaxBetaUrl);